import React from "react";
import DrpEeduHeader from "../../components/DrpEeduHeader";
import DrpEduNavbar from "../../components/DrpEduNavbar";
import "../../styles/MbbsCountryPage.css";
import Footer from "../../components/Footer";
const IndiaMbbs = () => {
  return (
    <>
      <DrpEeduHeader />
      <DrpEduNavbar />{" "}
      <div className="mbbs-country-page">
        <section className="country-header">
          <h2 className="country-title">🩺 MBBS Education in India</h2>
        </section>

        <section className="details-section">
          <div className="detail-item">
            <h3 className="detail-title">Duration:</h3>
            <p className="detail-text">
              5.5 years (4.5 years academic + 1 year compulsory internship)
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Eligibility:</h3>
            <ul className="detail-list">
              <li>10+2 with Physics, Chemistry, Biology, and English</li>
              <li>Minimum 50% marks (40% for reserved categories)</li>
              <li>
                Must qualify NEET-UG (National Eligibility cum Entrance Test)
              </li>
            </ul>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Intake:</h3>
            <p className="detail-text">
              Admission via NEET-UG score; counseling through MCC (for central
              quota) and state authorities
            </p>
          </div>
          <div className="detail-item">
            <h3 className="detail-title">Regulatory Body:</h3>
            <p className="detail-text">National Medical Commission (NMC)</p>
          </div>
        </section>

        <section className="universities-section">
          <h2 className="section-title">
            🎓 Top MBBS Universities/Colleges in India
          </h2>
          <div className="university-list">
            <div className="university-card">
              <h3 className="university-name">
                All India Institute of Medical Sciences (AIIMS), New Delhi
              </h3>
              <p className="university-description">
                Premier government medical institute in India. Autonomous and
                highly competitive.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Post Graduate Institute of Medical Education and Research
                (PGIMER), Chandigarh
              </h3>
              <p className="university-description">
                Renowned for postgraduate education but has UG MBBS intake too
                (via NEET).
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Christian Medical College (CMC), Vellore
              </h3>
              <p className="university-description">
                Prestigious private medical college. Strong clinical training
                and service-based education.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Armed Forces Medical College (AFMC), Pune
              </h3>
              <p className="university-description">
                Run by the Indian Armed Forces. Excellent academics and job
                assurance in defense medical services.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Maulana Azad Medical College (MAMC), New Delhi
              </h3>
              <p className="university-description">
                Affiliated to the University of Delhi. Top-ranked government
                medical college.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                King George's Medical University (KGMU), Lucknow
              </h3>
              <p className="university-description">
                State government university with strong academic reputation.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">JIPMER, Puducherry</h3>
              <p className="university-description">
                Autonomous under MoHFW. Offers MBBS through NEET.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                Banaras Hindu University (BHU) – Institute of Medical Sciences,
                Varanasi
              </h3>
              <p className="university-description">
                Central university status. Offers MBBS via NEET.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">Grant Medical College, Mumbai</h3>
              <p className="university-description">
                Among the oldest medical colleges in India. Affiliated with
                Maharashtra University of Health Sciences.
              </p>
            </div>
            <div className="university-card">
              <h3 className="university-name">
                St. John’s Medical College, Bangalore
              </h3>
              <p className="university-description">
                Private college under Catholic Bishops’ Conference of India.
                Strong focus on rural and community health.
              </p>
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </>
  );
};

export default IndiaMbbs;
